import type { ValueOf } from 'type-fest';

export const BuildSteps = {
  Queued: 'QUEUED',
  ApplyingBuild: 'APPLYING_BUILD',
  AnalyzingDeps: 'ANALYZING_DEPS',
  Failed: 'FAILED',
  Succeeded: 'SUCCEEDED',
} as const;

export type BuildStep = ValueOf<typeof BuildSteps>;
